(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach(
            (element) => {
              element.classList.remove('active');
            }
          );
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-configurable"]) return;
  try {
    

   (function() {
    // estimer date de livraison
    if(document.getElementById('fromDate')) {
      
      var dateDebut = 3;
      var dateFin = 5;

      var fromDate = Date.today().addDays(dateDebut);
      if (fromDate.is().saturday() || fromDate.is().sunday()) { 
        fromDate = fromDate.next().monday();
        dateFin = dateFin +1;
      }
      var toDate = Date.today().addDays(dateFin);
      if (toDate.is().saturday() || toDate.is().sunday()) { 
        toDate = toDate.next().monday(); 
      }
      document.getElementById('fromDate').innerHTML = fromDate.toString('dd/MM');
      document.getElementById('toDate').innerHTML = toDate.toString('dd/MM');
    }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    // estimer date de livraison
    if (document.getElementById('fromDate')) {
      var dateDebut = 3;
      var dateFin = 5;

      var fromDate = Date.today().addDays(dateDebut);
      if (fromDate.is().saturday() || fromDate.is().sunday()) {
        fromDate = fromDate.next().monday();
        dateFin = dateFin + 1;
      }
      var toDate = Date.today().addDays(dateFin);
      if (toDate.is().saturday() || toDate.is().sunday()) {
        toDate = toDate.next().monday();
      }
      document.getElementById('fromDate').innerHTML = fromDate.toString('dd/MM');
      document.getElementById('toDate').innerHTML = toDate.toString('dd/MM');
    }
  })();

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      $('#wishlistCard').remove();
    },
    false
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product_bak_mzp_20220513_102905"]) return;
  try {
    
  (function () {
    // estimer date de livraison
    if (document.getElementById('fromDate')) {
      var dateDebut = 3;
      var dateFin = 5;

      var fromDate = Date.today().addDays(dateDebut);
      if (fromDate.is().saturday() || fromDate.is().sunday()) {
        fromDate = fromDate.next().monday();
        dateFin = dateFin + 1;
      }
      var toDate = Date.today().addDays(dateFin);
      if (toDate.is().saturday() || toDate.is().sunday()) {
        toDate = toDate.next().monday();
      }
      document.getElementById('fromDate').innerHTML = fromDate.toString('dd/MM');
      document.getElementById('toDate').innerHTML = toDate.toString('dd/MM');
    }
  })();

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      $('#wishlistCard').remove();
    },
    false
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"] && !Shopify.designMode) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
